module.exports = "/_next/static/images/fitness_illustration-387250bd151ed4f5557c16a9002155d2.svg";